import { useLocation } from "react-router-dom";

const Navbar = () => {
  const location = useLocation();

  // Hide the navbar when the user is on the login page
  if (location.pathname === "/login") {
    return null; // Don't render anything if on login page
  }

  return (
    <nav className="navbar navbar-expand-lg bg-primary" data-bs-theme="dark">
      <div className="container-fluid">
        <a className="navbar-brand" href="/dashboard"><img src="images/small.png" style={{width:"50px", height:"50px"}}></img>Inez Pangako</a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarColor03"
          aria-controls="navbarColor03"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarColor03">
          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <a className="nav-link active" href="/">Home</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/inventory">Inventory</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/saleshistory">Sales</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/POS">POS</a>
            </li>
          </ul>
          {/* Align Logout to the right */}
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <a className="nav-link" href="/logout">Logout</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
